var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoFsYet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 84,
    viewBox: "0 0 81 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "empty-folder 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Exp-3.-G"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.5191 34.3281H19.3815C18.3889 34.3281 17.4375 34.7222 16.7355 35.4242C16.0347 36.125 15.6406 37.0764 15.6406 38.069V45.5508H65.5191V34.3281Z",
    fill: "url(#paint0_linear_9599_11784)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6406 38.9258H65.5191V41.2489H15.6406V38.9258Z",
    fill: "url(#paint1_linear_9599_11784)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.5194 33.1784C65.5194 32.1871 65.1254 31.2356 64.4234 30.5336C63.7213 29.8328 62.7699 29.4375 61.7786 29.4375C57.3132 29.4375 49.9574 29.4375 46.0195 29.4375C44.4146 29.4375 42.9893 30.4613 42.4756 31.9813C41.7548 34.1173 40.8408 36.8208 40.8408 36.8208H65.5194V33.1784Z",
    fill: "url(#paint2_linear_9599_11784)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.6217 46.3197C68.8461 44.8807 68.4296 43.4143 67.482 42.307C66.5343 41.1997 65.1501 40.5625 63.6924 40.5625C52.693 40.5625 28.9882 40.5625 17.9888 40.5625C16.5311 40.5625 15.147 41.1997 14.1993 42.307C13.2516 43.4143 12.8351 44.8807 13.0596 46.3197C14.329 54.4399 16.6134 69.0618 17.7357 76.2468C18.116 78.6759 20.2071 80.4653 22.6649 80.4653H59.0163C61.4741 80.4653 63.5652 78.6759 63.9456 76.2468C65.0678 69.0618 67.3523 54.4399 68.6217 46.3197Z",
    fill: "url(#paint3_linear_9599_11784)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0596 46.3197L13.6992 50.4098C13.4735 48.9695 13.9686 47.5031 14.9163 46.3958C15.864 45.2885 17.2481 44.6513 18.7058 44.6513H62.9754C64.4331 44.6513 65.8173 45.2885 66.765 46.3958C67.7126 47.5031 68.2077 48.9695 67.982 50.4098L68.6217 46.3197C68.8461 44.8807 68.4296 43.4143 67.482 42.307C66.5343 41.1997 65.1501 40.5625 63.6924 40.5625C52.693 40.5625 28.9882 40.5625 17.9888 40.5625C16.5311 40.5625 15.147 41.1997 14.1993 42.307C13.2516 43.4143 12.8351 44.8807 13.0596 46.3197Z",
    fill: "#E9F3FC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9928 70.2986C37.9928 68.922 36.8768 67.8047 35.4989 67.8047C32.7319 67.8047 28.2915 67.8047 25.5232 67.8047C24.1466 67.8047 23.0293 68.922 23.0293 70.2986V72.7925C23.0293 74.1704 24.1466 75.2865 25.5232 75.2865H35.4989C36.8768 75.2865 37.9928 74.1704 37.9928 72.7925C37.9928 71.9907 37.9928 71.1017 37.9928 70.2986Z",
    fill: "#E9F3FC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.7041 8.3121C42.0533 0.671963 53.7461 1.16576 46.9389 8.3121H40.7041Z",
    fill: "url(#paint4_linear_9599_11784)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.7041 10.2461C42.0533 17.885 53.7461 17.3924 46.9389 10.2461H40.7041Z",
    fill: "url(#paint5_linear_9599_11784)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.5927 10.5369H48.9423C49.6306 10.5369 50.1893 9.97825 50.1893 9.28993C50.1893 8.60161 49.6306 8.04297 48.9423 8.04297H40.5927C39.9056 8.04297 39.3457 8.60161 39.3457 9.28993C39.3457 9.97825 39.9056 10.5369 40.5927 10.5369Z",
    fill: "url(#paint6_linear_9599_11784)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1565"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.5029 32.459C31.8054 31.6514 32.2666 30.8872 32.8753 30.1888C33.1199 29.9082 33.0893 29.4818 32.8102 29.2383C32.5296 28.9937 32.1029 29.023 31.8596 29.3034C31.1407 30.1278 30.6001 31.032 30.241 31.9855C30.1099 32.3335 30.2873 32.7221 30.6352 32.8532C30.9829 32.983 31.3718 32.807 31.5029 32.459Z",
    fill: "#738BAB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.1865 28.2819C36.1826 27.6808 37.3497 27.1895 38.6766 26.8317C39.035 26.7358 39.2485 26.366 39.1511 26.0066C39.0552 25.6483 38.6855 25.4347 38.3258 25.5308C36.8681 25.9239 35.5868 26.4682 34.491 27.1266C34.173 27.3183 34.0692 27.7327 34.2611 28.052C34.4527 28.37 34.8672 28.4738 35.1865 28.2819Z",
    fill: "#738BAB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.9292 26.2663C43.5213 26.1255 44.9639 25.9138 46.2681 25.6416C46.6326 25.5666 46.8661 25.2099 46.791 24.8454C46.7146 24.4812 46.358 24.2477 45.9935 24.3228C44.7354 24.5847 43.3446 24.7878 41.8117 24.9229C41.4404 24.9568 41.1664 25.2832 41.1987 25.6534C41.2326 26.0247 41.559 26.2986 41.9292 26.2663Z",
    fill: "#738BAB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.7905 24.6604C51.294 24.1137 52.5364 23.4666 53.5538 22.7542C53.8585 22.5401 53.9326 22.1196 53.7201 21.816C53.506 21.5113 53.0856 21.4372 52.7806 21.6499C51.8491 22.3031 50.708 22.8939 49.3309 23.3952C48.9805 23.5226 48.801 23.9086 48.9281 24.2577C49.0555 24.6081 49.4415 24.7875 49.7905 24.6604Z",
    fill: "#738BAB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.96 20.4596C56.9617 19.1135 57.4428 17.6742 57.536 16.2756C57.5609 15.9043 57.28 15.5832 56.9086 15.5584C56.5385 15.5333 56.2161 15.8145 56.1926 16.1856C56.1149 17.3468 55.7104 18.5386 54.8797 19.6544C54.6572 19.9533 54.72 20.3758 55.0173 20.5972C55.3161 20.8197 55.7389 20.7582 55.96 20.4596Z",
    fill: "#738BAB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.4642 11.7538C55.7069 10.4394 54.6149 9.39717 53.4022 8.82411C53.0663 8.66644 52.664 8.81055 52.505 9.1467C52.3473 9.48263 52.4914 9.88491 52.8274 10.0426C53.8104 10.506 54.6832 11.3617 55.297 12.4267C55.4824 12.7485 55.8953 12.8593 56.2171 12.6739C56.5388 12.4884 56.6497 12.0755 56.4642 11.7538Z",
    fill: "#738BAB"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9599_11784",
    x1: 15.6406,
    y1: 37.4954,
    x2: 65.5191,
    y2: 37.4954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9599_11784",
    x1: 15.6406,
    y1: 40.0867,
    x2: 65.5191,
    y2: 40.0867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4BBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8DA3BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9599_11784",
    x1: 15.9016,
    y1: 37.4941,
    x2: 65.7801,
    y2: 37.4941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9599_11784",
    x1: 13.0009,
    y1: 60.5139,
    x2: 68.6815,
    y2: 60.5139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CADCF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_9599_11784",
    x1: 40.7041,
    y1: 5.53885,
    x2: 49.0525,
    y2: 5.53885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CADCF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_9599_11784",
    x1: 40.7041,
    y1: 13.0193,
    x2: 49.0525,
    y2: 13.0193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CADCF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_9599_11784",
    x1: 39.347,
    y1: 9.28993,
    x2: 50.1893,
    y2: 9.28993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#559AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E69EF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoFsYet);
export default __webpack_public_path__ + "static/media/noFsYet.cd93fdb6aa18d2ed7358d82caf4aec0e.svg";
export { ForwardRef as ReactComponent };